// Galerie terrain — vraies photos de missions WEYB (lots 1-3, fournies par le client).
export const GALLERY = [
    {
        src: "/assets/terrain-hannover.jpg",
        caption: { fr: "Smart Factory Academy — Hannover Messe, Allemagne", en: "Smart Factory Academy — Hannover Messe, Germany" },
    },
    {
        src: "/assets/terrain-export-morocco.jpg",
        caption: { fr: "Séminaire Export Morocco Now Women — Casablanca", en: "Export Morocco Now Women seminar — Casablanca" },
    },
    {
        src: "/assets/terrain-salon-amdie.jpg",
        caption: { fr: "Salon international — pavillon national du Maroc", en: "International trade fair — Morocco pavilion" },
    },
    {
        src: "/assets/terrain-crte.jpg",
        caption: { fr: "Centre de Recherches et des Technologies des Eaux — Tunisie", en: "Water Research and Technologies Centre — Tunisia" },
    },
    {
        src: "/assets/terrain-enova.jpg",
        caption: { fr: "Visite industrielle — ENOVA Robotics, Tunisie", en: "Industrial visit — ENOVA Robotics, Tunisia" },
    },
    {
        src: "/assets/terrain-workshop-agadir.jpg",
        caption: { fr: "Workshop de formation — Agadir, Maroc", en: "Training workshop — Agadir, Morocco" },
    },
    {
        src: "/assets/terrain-b2b-roseblanche.jpg",
        caption: { fr: "Rencontre B2B — salon international", en: "B2B meeting — international trade fair" },
    },
    {
        src: "/assets/terrain-export-morocco-groupe.jpg",
        caption: { fr: "Programme Export Morocco Now Women — Marrakech", en: "Export Morocco Now Women programme — Marrakech" },
    },
    {
        src: "/assets/terrain-matinale-export.jpg",
        caption: { fr: "5e Matinale de l'Export — Laico Tunis", en: "5th Export Morning — Laico Tunis" },
    },
    {
        src: "/assets/terrain-ccis.jpg",
        caption: { fr: "Rencontre institutionnelle — CCIS", en: "Institutional meeting — CCIS" },
    },
    {
        src: "/assets/terrain-immotech.webp",
        caption: { fr: "Rendez-vous ImmoTech — Club Immobilier Côte d'Azur, 2024", en: "ImmoTech event — Club Immobilier Côte d'Azur, 2024" },
    },
    {
        src: "/assets/terrain-formation.jpg",
        caption: { fr: "Formation export — cohorte d'entrepreneures", en: "Export training — women entrepreneurs cohort" },
    },
    {
        src: "/assets/terrain-formation-groupe.jpg",
        caption: { fr: "Formation commerce international — Tunisie", en: "International trade training — Tunisia" },
    },
    {
        src: "/assets/terrain-mission-bureau.jpg",
        caption: { fr: "Mission de conseil — accompagnement en entreprise", en: "Consulting mission — in-company support" },
    },
    {
        src: "/assets/terrain-startup-village.jpg",
        caption: { fr: "Écosystème Startup Village", en: "Startup Village ecosystem" },
    },
];
